export default [
  {
    path: '/v2/admin/whole-sales',
    name: 'sale-invoice',
    meta: { requiresAuth: true },
    component: () => import('@/pages/sale-invoices/index.vue')
  },
  {
    path: '/v2/admin/whole-sales/create',
    name: 'sale-invoices-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/sale-invoices/create.vue')
  },
  {
    path: '/v2/admin/whole-sales/:id/edit',
    name: 'sale-invoices-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/sale-invoices/edit.vue')
  }
]
